module.exports = __webpack_public_path__ + "img/review-avatar.16085ad7.png";